<template>
  <div
    class="scrap-bd tb"
    v-if="funcView.offline_service_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addEvent"
            v-if="funcView.offline_service_add"
          >{{funcView.offline_service_add}}</el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="table-set"
            style="vertical-align: top"
            @click.native="exportTable('deviceScrapExport', formSearch)"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            placeholder="Modem SN"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['action']"
      >
        <template
          slot="action"
          slot-scope="scope"
        >
          <span>
            <el-button
              type="text"
              size="mini"
              @click="editBtn(scope.row)"
              v-if="funcView.offline_service_edit && scope.row.approvalState===1"
            >{{funcView.offline_service_edit}}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="seeBtn(scope.row)"
              v-if="funcView.offline_service_preview&& scope.row.approvalState>1"
            >{{funcView.offline_service_preview}}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="onApproval(scope.row)"
              v-if="funcView.offline_service_approval && scope.row.approvalState===1"
            >{{funcView.offline_service_approval}}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="deleteBtn(scope.row)"
              v-if="funcView.offline_service_delete&& scope.row.approvalState===1"
            >{{funcView.offline_service_delete}}</el-button>
            <el-button
              type="text"
              size="mini"
              @click="issueBtn(scope.row)"
              v-if="funcView.offline_service_issue&& scope.row.approvalState===10"
            >{{funcView.offline_service_issue}}</el-button>
          </span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <offlineService-modemSn-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
    >
    </offlineService-modemSn-dialog>
    <!-- 编辑返回结果 -->
    <!-- <device-acrap-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
    >
    </device-acrap-dialog> -->
    <!-- 查看 -->
    <approval-dialog
      v-if="dialogVisible1"
      :model="dialogModel1"
      @close="dialogVisible1 = false"
    ></approval-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';

// import deviceAcrapDialog from '@/pages/crm/components/deviceAcrapDialog.vue';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import offlineServiceModemSnDialog from './children/offlineService_modemSn_dialog.vue';

export default {
  name: 'offlineService',
  components: {
    offlineServiceModemSnDialog,
    // deviceAcrapDialog,
    approvalDialog
  },
  data() {
    return {
      provide: true,
      tableCode: 'offlineService',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1
      },
      totalRows: null,
      tableList: [],
      dialogVisible: false,
      dialogModel: {},
      // 查看
      dialogModel1: {},
      dialogVisible1: false,
    };
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.serviceModemPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    editReturnType(row) {
      this.dialogVisible = true;
      this.dialogModel.scrapApplyId = row.scrapApplyId;
    },
    addEvent() {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('asm_offlineService.tjtxb');
      // this.dialogModel1.changeId = row.scrapApplyId;
      this.dialogVisible = true;
    },
    editBtn(row) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('asm_offlineService.bian_ji_tong_xun_ban');
      this.dialogModel.serviceModemId = row.serviceModemId;
      this.dialogVisible = true;
    },
    seeBtn(row) {
      this.jump('/examine/approvalDetail', {
        workflowType: 'modem_service',
        bizId: row.serviceModemId,
        showProcess: true,
      });
    },
    // 删除
    // 状态，0-无效，1-有效，3-删除
    deleteBtn(row) {
      const tips = this.$t('asm_offlineService.nqdyscctxbfwm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.serviceModemUpdateState}/${row.serviceModemId}/3`).then(() => {
            this.$message({
              message: this.i18n.com_delete_success,
              type: 'success'
            });
            this.getTableList();
          });
        })
        .catch(() => { });
    },
    // 下发数据
    issueBtn(row) {
      this.jump('/offline/serviceAdd', {
        serviceModemId: row.serviceModemId,
      });

    },
    onApproval(row) {
      const tips = this.$t('asm_offlineService.nqdytjspctxbfwm');
      this.$showConfirm(tips).then(() => {
        const params = {
          ...row,
          isStartApprove: 1
        };
        this.$postJSON(apis.serviceModemSaveOrUpdate, params, true).then(() => {
          this.$message({
            type: 'success',
            message: this.i18n.com_edit_success
          });
          this.getTableList();
        });

      });


      // this.jump('/examine/approvalDetail', {
      //   workflowType: row.workflowType,
      //   bizId: row.scrapApplyId,
      // });
    },
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();
    this.getTableList();
  },
  activated() {
    this.getTableList();
  },

};
</script>

<style></style>
